import Grid from "@mui/material/Grid";
import React, { useRef, useEffect, useState } from "react";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Header from "layouts/authentication/components/Header";
import { useMsal } from "@azure/msal-react";

// Regular Training PDFs (Always Show)
const projectPDFs = {
  WhoDat: [
    "/forms/WhoDat/PreStartupForm/WDSLD-OP-FRM-00002%20%28Rev%20O%29%20Pre-Startup%20Form.pdf",
  ],
  WhoDatREG: [
    "/forms/WhoDat/PreStartupForm/WDSLD-OP-FRM-00002%20%28Rev%20O%29%20Pre-Startup%20Form.pdf",
  ],
  WhoDatADV: [
    "/forms/WhoDat/PreStartupForm/WDSLD-OP-FRM-00002%20%28Rev%20O%29%20Pre-Startup%20Form.pdf",
  ],
};

function PreStartupForm() {
  const iframeRef = useRef(null);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const userRoles = activeAccount?.idTokenClaims?.roles || [];

  // Get selected role or fallback to first available role
  const [selectedRole, setSelectedRole] = useState(
    localStorage.getItem("selectedRole") || userRoles[0] || ""
  );

  useEffect(() => {
    const storedRole = localStorage.getItem("selectedRole");
    if (storedRole && selectedRole !== storedRole) {
      setSelectedRole(storedRole);
    }
  }, []);

  // Always include regular training PDFs
  const availableLinks = projectPDFs[selectedRole] || [];

  // Function to toggle full-screen mode
  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      iframeRef.current.requestFullscreen().catch((err) => {
        alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
      });
    } else {
      document.exitFullscreen();
    }
  };

  return (
    <DashboardLayout>
      <Header title="Pre-Startup Form" />
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item xs={true}>
          <DashboardNavbar />
        </Grid>
        <Grid item sx={{ marginTop: "2rem" }}>
          <MDButton color="info" onClick={toggleFullScreen}>
            Toggle Full Screen
          </MDButton>
        </Grid>
      </Grid>

      {availableLinks.length > 0 ? (
        availableLinks.map((link, index) => (
          <div key={index} style={{ position: "relative", paddingTop: "56.25%" }}>
            <iframe
              ref={iframeRef}
              title={`Pre-Startup Form ${index + 1}`}
              src={link}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          </div>
        ))
      ) : (
        <p style={{ textAlign: "center", fontSize: "20px", fontWeight: "bold" }}>
          No PDFs Available for Your Selected Role
        </p>
      )}
    </DashboardLayout>
  );
}

export default PreStartupForm;
